import React, { useState } from 'react';
import CustomSwitch from '../../../../../shared/CustomSwitch/CustomSwitch';
import CustomCheckbox from '../../../../../shared/CustomCheckbox/CustomCheckbox';

const products = [
  {
    product: 'Internet Service',
    serviceType: 'ISP',
    location: 'ISP Service: 302 TEAKWOOD DR 294889529 SC',
    status: 'Active',
    id: 'kebwhb',
    summaryData: [
      {
        id: '1',
        description: 'Broadband/TV Modem',
        recurrence: 'Recurs monthly',
        charge: '$ 8.99',
      },
      {
        id: '2',
        description: 'Service Extension Installation',
        recurrence: 'Recurs monthly',
        charge: '$ 50.00',
      },
      {
        id: '3',
        description: 'Internet Service 1GB/1GB',
        recurrence: 'Recurs monthly',
        charge: '$ 129.95',
      },
      {
        id: '4',
        description: 'Internet Only Service Fee',
        recurrence: 'Recurs monthly',
        charge: '$ 0.00',
      },
      {
        id: '5',
        description: 'Wi-Fi Network Extender',
        recurrence: 'Recurs monthly',
        charge: '$ 4.99',
      },
    ],
  },
];

export default function ProductOrService() {
  const [isOn, setISon] = useState(false);
  const [id, setId] = useState('kebwhb');
  return (
    <div className="sub-card" id="invoice-payments">
      <div className="garden-wall-card-header">
        <h4 className="card-title">Payments</h4>
       
      </div>
      <div className="sc-table">
        <div className="sc-table-head">
          <div className="sc-table-head-cell">Products</div>
          <div className="sc-table-head-cell">Service Type</div>
          <div className="sc-table-head-cell">Location</div>
          <div className="sc-table-head-cell" style={{ maxWidth: 100 }}>
            Status
          </div>
        </div>
        <div
          className="sc-table-body"
          style={{
            display: 'flex',
            flexDirection: 'column',
            marginTop: 10,
            gap: 10,
          }}
        >
          {products.map((tr) => (
            <div className="products-tables">
              <div>
                <div className="sc-table-row">
                  <div className="sc-table-th-cell">{tr.product}</div>
                  <div className="sc-table-th-cell">{tr.serviceType}</div>
                  <div className="sc-table-th-cell">{tr.location}</div>
                  <div className="sc-table-th-cell" style={{ maxWidth: 100 }}>
                    {tr.status}
                  </div>
                </div>
              </div>
              {id === tr.id && (
                <div className="garden-wall-normal-card product-inner-table">
                  <div className="product-address">
                    302 TEAKWOOD DR, WALTERBORO, SC
                  </div>
                  <div className="product-service">
                    ISP Service: 302 TEAKWOOD DR 294889529 SC
                  </div>
                  <h5 className="product-sub-title">Summary</h5>
                  <div className="sc-table">
                    <div className="sc-table-head">
                      <div className="sc-table-head-cell">Description</div>
                      <div className="sc-table-head-cell">Recurrence</div>
                      <div className="sc-table-head-cell">Charge</div>
                    </div>
                    <div>
                      {tr.summaryData.map((item) => (
                        <div className="sc-table-row">
                          <div className="sc-table-th-cell">
                            {item.description}
                          </div>
                          <div className="sc-table-th-cell">
                            {item.recurrence}
                          </div>
                          <div className="sc-table-th-cell">{item.charge}</div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

